export default "__VITE_ASSET__1bf9f5bf__"